import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 md:py-32 px-4 relative overflow-hidden" data-id="element-137">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-138" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-dark-card border-2 border-gold mb-8 shadow-[0_0_30px_rgba(212,168,67,0.2)]" data-id="element-140">
          <ShieldCheck className="w-12 h-12 text-gold" data-id="element-141" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-heading font-bold text-white mb-8" data-id="element-142">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="space-y-6 text-lg md:text-xl text-gray-300 mb-12" data-id="element-143">
          <p data-id="element-144">
            Abrís los 6 tomos. Los trabajás con los ejercicios. Los usás en tu
            vida real.
          </p>
          <p data-id="element-145">
            Si en 7 días no es lo que esperabas, devolución del 100%. Sin
            formularios. Sin drama. Sin vueltas.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="bg-dark-card/80 border border-dark-border rounded-xl p-6 inline-block" data-id="element-146">
          <p className="text-gold-light font-bold text-xl mb-2" data-id="element-147">
            Tasa de devoluciones: menos del 1%.
          </p>
          <p className="text-gray-400 italic" data-id="element-148">
            Porque cuando el material es real, la garantía no da miedo.
          </p>
        </motion.div>
      </div>
    </section>;
}